import { render, staticRenderFns } from "./techAchievements.vue?vue&type=template&id=08b1aab2&scoped=true&"
import script from "./techAchievements.vue?vue&type=script&lang=js&"
export * from "./techAchievements.vue?vue&type=script&lang=js&"
import style0 from "./techAchievements.vue?vue&type=style&index=0&id=08b1aab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1aab2",
  null
  
)

export default component.exports